/* Youtube Overlay */
window.onYouTubeIframeAPIReady = () => {
  $(".video-wrap .video").each(function () {
    var toggle = $(this).closest(".video-wrap").find(".video-toggle");
    var player;
    player = new YT.Player($(this).attr("id"), {
      videoId: $(this).attr("id"), // YouTube Video ID
      width: 560, // Player width (in px)
      height: 316, // Player height (in px)
      playerVars: {
        autoplay: 0, // Auto-play the video on load
        controls: 1, // Show pause/play buttons in player
        showinfo: 0, // Hide the video title
        modestbranding: 1, // Hide the Youtube Logo
        start: 0,
        loop: 0, // Run the video in a loop
        fs: 0, // Hide the full screen button
        cc_load_policy: 0, // Hide closed captions
        iv_load_policy: 3, // Hide the Video Annotations
        autohide: 0, // Hide video controls when playing
      },
      events: {
        onReady: function (e) {
          if (toggle.closest(".industry").length) {
            toggle.closest(".video-wrap").find(".video-holder__inner").css({
              // paddingBottom: (( $('img', toggle).height() / $('img', toggle).width() ) * 100).toFixed(1) + '%'
            });
          }
          toggle.parent().addClass("ready");
          player.seekTo(0).stopVideo();
          // Fitvids
          player.seekTo(0).stopVideo();
          toggle.click(function () {
            player.seekTo(0).playVideo();
            toggle.parent().addClass("playing");
          });
          toggle
            .closest(".video-wrap")
            .find(".video-close")
            .click(function () {
              toggle.parent().removeClass("playing");
              setTimeout(function () {
                player.stopVideo();
              }, 600);
            });
          $(document).keyup(function (e) {
            if (
              e.key === "Escape" &&
              toggle.parent().hasClass("playing") &&
              toggle.closest(".industry").length
            ) {
              toggle.parent().removeClass("playing");
              setTimeout(function () {
                player.stopVideo();
              }, 600);
            }
          });
        },
      },
    });
  });
};

const prodCat = {
  init() {
    $(".leftmenu__item.active").find(".leftmenu__submenu").slideDown();

    $("[data-cat-toggle]").on("click", function () {
      let allLi = $(".leftmenu__item");
      let closestLi = $(this).closest(".leftmenu__item");

      if (closestLi.hasClass("active")) {
        closestLi.removeClass("active");
        closestLi.find(".leftmenu__submenu").slideUp();
      } else {
        allLi.removeClass("active");
        $(".leftmenu__submenu").slideUp();
        $(this).closest(".leftmenu__item").addClass("active");
        $(this)
          .closest(".leftmenu__item")
          .find(".leftmenu__submenu")
          .slideDown();
      }
    });

    /* Smooth scrolling */
    $(document).on("click", 'a[href^="#"]', function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 150,
        },
        500
      );
    });

    /* Youtube API */
    let yt_api = "https://www.youtube.com/iframe_api";
    if ($(".video-toggle").length) {
      var tag = document.createElement("script");
      tag.src = yt_api;
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  },
};

export default prodCat;
